import { useEffect } from "react";
import { Routes, Route } from "react-router";

// import styles
import "./styles/App.scss";

// components
import Home from "./components/home/Home.js";
import Landing from "./components/landing/Landing.js";
import Acting from "./components/acting/Acting.js";
  import ActingHome from "./components/acting/ActingHome.js";
  import Media from "./components/acting/Media.js";
  import Resume from "./components/acting/Resume.js";
import Music from "./components/music/Music.js";
  import MusicHome from "./components/music/MusicHome.js";
  import Discography from "./components/music/Discography.js";
  import MusicAbout from "./components/music/MusicAbout.js";

// import icons
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope, faCalendar, faDownload, faPhone, faGlobe, faBackward, faForward, faPlay, faPause, faTimes } from "@fortawesome/free-solid-svg-icons";
import { faCopyright } from "@fortawesome/free-regular-svg-icons";
import { faXTwitter, faSpotify, faInstagram, faFacebook, faYoutube, faItunesNote, faAmazon, faThreads } from "@fortawesome/free-brands-svg-icons";

// solid icons
library.add(faEnvelope, faCalendar, faDownload, faPhone, faGlobe, faBackward, faForward, faPlay, faPause, faTimes);
// regular icons
library.add(faCopyright);
// brand icons
library.add(faXTwitter, faSpotify, faInstagram, faFacebook, faYoutube, faItunesNote, faAmazon, faThreads);

function App() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div className="App body">
      <Routes>
        {/* HOME */}
        <Route path="/" element={<Home />}></Route>
        <Route path="/landing-page" element={<Landing />}></Route>
        {/* ACTING */}
        <Route path="acting" element={<Acting />}>
          <Route index element={<ActingHome />}></Route>
          <Route path="media" element={<Media />}></Route>
          <Route path="resume" element={<Resume />}></Route>
        </Route>
        {/* MUSIC */}
        <Route path="/music" element={<Music />}>
          <Route index element={<MusicHome />}></Route>
          <Route path="discography" element={<Discography />}></Route>
          <Route path="about" element={<MusicAbout />}></Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
